import { defineMessages } from 'react-intl';

export const scope = 'app.components.SignupCtaBanner';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Bắt đầu đặt hàng ngay hôm nay',
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage:
      'Tạo tài khoản miễn phí để nhận ngay set 10 món quà tặng\nvà mở khoá mức giá ưu đãi dành cho doanh nghiệp.',
  },
  createFreeAccount: {
    id: `${scope}.createFreeAccount`,
    defaultMessage: 'Tạo tài khoản miễn phí',
  },
  signIn: {
    id: `${scope}.signIn`,
    defaultMessage: 'Đăng nhập',
  },
  partneringWithKamereo: {
    id: `${scope}.partneringWithKamereo`,
    defaultMessage: 'Đồng hành cùng KAMEREO',
  },
  partneringSubtitle: {
    id: `${scope}.partneringSubtitle`,
    defaultMessage: 'tối ưu vận hành doanh nghiệp F&B.',
  },
  stat1Label: {
    id: `${scope}.stat1Label`,
    defaultMessage: 'SKU',
  },
  stat2Label: {
    id: `${scope}.stat2Label`,
    defaultMessage: 'Giao đúng giờ',
  },
  stat3Label: {
    id: `${scope}.stat3Label`,
    defaultMessage: 'Hoàn thành đơn',
  },
});
